import { render } from "./ListeForumPage.vue?vue&type=template&id=3f02e0f3&ts=true"
import script from "./ListeForumPage.vue?vue&type=script&lang=ts"
export * from "./ListeForumPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__